export default {"src":"/_next/static/media/warning.f8fa17bf.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};